var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16211 8.80222C1.16211 14.2701 5.94557 18.7919 8.06285 20.5255L8.06368 20.5262C8.36728 20.7748 8.51913 20.8991 8.74542 20.9628C8.92145 21.0124 9.18037 21.0124 9.35641 20.9628C9.5829 20.8991 9.73515 20.7746 10.0393 20.5255C12.1566 18.7919 16.9398 14.2701 16.9398 8.80218C16.9398 6.73291 16.1087 4.74841 14.6293 3.28521C13.1498 1.82202 11.1433 1 9.05104 1C6.95878 1 4.95217 1.822 3.47271 3.2852C1.99326 4.74839 1.16211 6.73295 1.16211 8.80222Z",
    fill: "#F38D00",
    stroke: "#F5FAFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.af99e1035dc6bfe5f15f03012e7e71f5.svg";
export { ForwardRef as ReactComponent };